<template>
    <div
      class="">
      <v-layout wrap>
        <v-flex>
          <section>
  
            <v-card flat class="pa-3 px-7 border-radius-card">
              <div>
                <v-tabs
                  v-model="tabs"
                  dense
                  background-color="transparent"
                  slider-size="5"
                  color="#240087">
                  <v-tab
                    v-for="(item, index) in tab"
                    :key="index"
                    v-on:change="changeQuery(item.link)">
                    <span
                      class="body-2 font-weight-medium text-capitalize">
                      {{ item.title }}
                    </span>
                  </v-tab>
                </v-tabs>
                <v-divider style="border-color: #EBEEF2;"></v-divider>
              </div>
  
  
              <div>
  
                <General v-if="tabs === 0"
                  :form="form" />
  
                <Password v-if="tabs === 1" />
  
                <!-- <Preferences v-if="tabs === 1" /> -->
              </div>
            </v-card>
  
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data() {
        return {
          tabs: 0,
          tab: [
            {
              title: 'Edit Profile',
              link: '/profile?menu=profile'
            },
            // {
            //   title: 'Preferences',
            //   link: '/profile?menu=preferences'
            // },
            {
              title: 'Ganti Password',
              link: '/profile?menu=security'
            }
          ],
  
  
          form: {},
  
          process: {
            load: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      computed: {
        rps() {
          return this.$vuetify.breakpoint.name
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+93}, ${g+120}, ${b+12})`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.05)`
        },
  
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      components: {
        General: () => import(/* webpackPrefetch: true */ '@/components/profile/general.vue'),
        Password: () => import(/* webpackPrefetch: true */ '@/components/profile/password.vue')
      },
      watch: {
        '$route.query.menu': function(val) {
          this.changeLink(val)
        }
      },
      mounted () {
        this.fetchDetail()
        this.changeLink(this.$route.query.menu)
      },
      methods: {
        async fetchDetail () {
          await get(`pos/profile_user/detail`)
          .then(response => {
            let res = response.data
  
            this.process.load = false
              
            if (res.status === 200) {
              this.form = res.results.data
            }
          })
        },
  
        changeLink (query) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          
          if (query !== undefined) {
            this.tabs = query === 'profile' ? 0 : 1
          } else {
            this.tabs = 0
          this.$router.push(this.tab[this.tabs].link)
          }
        },
        changeQuery (link) {
          this.$router.push(link)
        },
  
        updateTime () {
          let cd = new Date()
  
          this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
        },
        zeroPadding (num, digit) {
          let zero = ''
  
          for(let i = 0; i < digit; i++) {
            zero += '0'
          }
          return (zero + num).slice(-digit)
        }
      }
    }
  </script>
  
  <style>
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
  
      /* background-color: #718EBF; */
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    }
  
  
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
  </style>